import { renderInDocument } from '@spotahome/soyuz/client';

import EnforceLoginPage from './main';

renderInDocument(EnforceLoginPage);
